<div>

	<toolbar icon='VolCoordination'>

		<button class="btn btn-light" (click)='areaService.reloadData()' KendoTooltip [attr.title]="'Reload'">
			<i class='far fa-sync-alt reload-btn'></i>
		</button>

		<droplist [items]='[]' [popupConfig]='popupConfig' [navigation]='true'>
		</droplist>

		<div style='display:inline-block;width:300px'>
			<trimester-droplist [trimesterWindow]="trimesterWindow"></trimester-droplist>
		</div>

	</toolbar>

	<page-tabs [tabNames]='["Mentors", "Tab1", "Engagements"]' [pageService]='pageService'
		(layoutChange)='onLayoutChange($event)'>
		<ng-template pageTab1>
			<volunteering-mentors-views-part></volunteering-mentors-views-part>
		</ng-template>

		<ng-template pageTab2>
			<volunteering-mentors-tab-1-part></volunteering-mentors-tab-1-part>
		</ng-template>

		<ng-template pageTab3>
			<volunteering-mentors-tab-2-part></volunteering-mentors-tab-2-part>
		</ng-template>
	</page-tabs>

</div>